import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  Alert
} from "react-bootstrap";

import { AlertInfo } from "../../components/Alert/AlertInfo.jsx";
import { Card } from "../../components/Card/Card.jsx";
import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";

import { NavLink } from "react-router-dom";

import { Query, Mutation } from "react-apollo";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";
import { HttpLink } from 'apollo-link-http';

import NotificationSystem from "react-notification-system";
import { style } from "../../variables/Variables.jsx";

import Select from 'react-select';
import DateTimePicker from 'react-datetime-picker';


const restLink_cloudLimit = new HttpLink({ 
  uri: "/api/v1/cloud/",
  credentials: 'include'
});
const cloud_client = new ApolloClient({
  link: restLink_cloudLimit,
  cache: new InMemoryCache(),
});

const ADD_TODO = gql`
  mutation createOrUpdateCloudLimitAccountAccount($account_id: Int!, $vcpu: Int!, $ram: Int!, $storage: Int!){
    createOrUpdateCloudLimitAccount(input:{account_id: $account_id, vcpu: $vcpu, ram:$ram, storage:$storage}) {
      id
    }
  }
`;

const GET_CLOUDLIMIT = gql`
  query cloudLimitAccount($account_id: Int!){
    cloudLimitAccount(account_id:$account_id){
      id
      vcpu
      ram
      storage
    }
  }
`;

class CloudLimitItem extends Component {

  account_id;
  cloudLimitAccount_edit;

  constructor() {
    super();
    this.state = {
      alertInfo: "",
      datePublish: new Date(),
      dateUnpublish: null
    };


    this.start_publish_date = true;
    this.start_unpublish_date = true;
    this.start_active = true;
    this.start_blockcontent = true;
    
    
  }

  onChange_datePublish = datePublish => this.setState({ datePublish })
  onChange_dateUnpublish = dateUnpublish => this.setState({ dateUnpublish })

  handleCheckboxChange = (e) => {
    this.setState(state => ({
      ...state,
      checkboxValue_active: !this.state.checkboxValue_active
    }));

  }

  handleCheckboxChange_blockcontent = (e) => {
    this.setState(state => ({
      ...state,
      checkboxValue_blockcontent: !this.state.checkboxValue_blockcontent
    }));

  }


  handleSubmit = (event) => {
    event.preventDefault();
    
    this.setState({
      alertInfo: "Salvo com sucesso!"
    });

    setTimeout(() => {
      this.setState({
        alertInfo: ""
      })
    },3000);
  }

  
  render() {

    
    if(this.props.match.params.account_id) {
      this.account_id = this.props.match.params.account_id;
    } else {
      return (
        <div className="content">
          <Grid fluid>
            <strong>Cliente não especificado</strong>
          </Grid>
        </div>
      );
    }

    return (


      <Query
      client={cloud_client}
      query={GET_CLOUDLIMIT}
      variables={{account_id:this.account_id}}
      fetchPolicy='no-cache'
      >
      {({ loading, error, data }) => {
        if (loading) return <div>Carregando...</div>;
        if (error) return <div>Erro :(</div>;
          
          this.cloudLimitAccount_edit = data.cloudLimitAccount;

        return (

      <Mutation mutation={ADD_TODO} client={cloud_client}>
      {(createOrUpdateCloudLimitAccount, { data }) => {
      

      return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
            
              <NavLink
                  to="/Account"
                  className="btn btn-info btn-fill"
                  activeClassName=""
                >
                VOLTAR
              </NavLink>
              <NotificationSystem ref="notificationSystem" style={style} />

            
              <Card
                title={"Limites "}
                content={
                  <form 
                  onSubmit={e => {
                    this.handleSubmit(e);
                    e.preventDefault();
                    createOrUpdateCloudLimitAccount({variables: { 
                      account_id: this.account_id, 
                      ram: e.target.elements.ram.value,
                      vcpu: e.target.elements.vcpu.value,
                      storage: e.target.elements.storage.value
                    } });
                  }}
                  >

                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        name: "ram",
                        label: "Memória RAM em GB",
                        type: "number",
                        bsClass: "form-control",
                        placeholder: "Memória RAM em GB",
                        defaultValue: (this.cloudLimitAccount_edit ? this.cloudLimitAccount_edit.ram : "")
                      }
                    ]}
                  />

                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        name: "vcpu",
                        label: "Número de VCPUs",
                        type: "number",
                        bsClass: "form-control",
                        placeholder: "Número de VCPUs por socket",
                        defaultValue: (this.cloudLimitAccount_edit ? this.cloudLimitAccount_edit.vcpu : "")
                      }
                    ]}
                  />

                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        name: "storage",
                        label: "Storage em GB",
                        type: "number",
                        bsClass: "form-control",
                        placeholder: "Storage em GB",
                        defaultValue: (this.cloudLimitAccount_edit ? this.cloudLimitAccount_edit.storage : "")
                      }
                    ]}
                  />

                  <Row>
                    <Col md={10}>
                      <AlertInfo ref="alertSave" alertInfo={this.state.alertInfo} />
                    </Col>
                    <Col md={2}>
                      <Button bsStyle="info" pullRight fill type="submit">
                        Salvar
                      </Button>
                    </Col>
                  </Row>
                    <div className="clearfix" />
                  </form>
                }
              />

            </Col>
            
          </Row>
        </Grid>
      </div>
      )}}
      </Mutation>

      );
      }}
      </Query>
    );
  }
}

export default CloudLimitItem;
